/*
 * @Date: 2022-10-27 17:19:26
 * @LastEditors: guantingting
 * @LastEditTime: 2023-01-17 16:31:02
 */
export default [
  {
    path: '/rent/v2/mini/receiveCoupon',
    name: 'minReceiveCoupon',
    component: () => import('@/pages/c2c/receiveCoupon'),
    meta: { title: '领券', requireAuth: true },
  },
  {
    path: '/rent/v2/mini/c2c-introduce',
    name: 'minIntroduce',
    component: () => import('@/pages/c2c/introduce'),
    meta: { title: '房车推客', requireAuth: true },
  },
  {
    path: '/rent/v2/mini/rvPurchase',
    name: 'minPurchase',
    component: () => import('@/pages/secondHandCar/rvPurchase'),
    meta: { title: '房车选购', requireAuth: true },
  },
  {
    path: '/rent/v2/mini/secondCarIndex',
    name: 'minSecondCar',
    component: () => import('@/pages/secondHandCar/secondCarIndex'),
    meta: { title: '二手车', requireAuth: true },
  },
  {
    path: '/rent/v2/mini/ownerApply',
    name: 'minOwnerApply',
    component: () => import('@/pages/vehicleCustody/ownerApply'),
    meta: { title: '房车托管', requireAuth: true },
  },
]



// WEBPACK FOOTER //
// ./src/minRouter.js